import { Livelib } from 'Lib/livelib/Livelib';

const elLivelibRating = document.querySelector('.livelib-rating');
const cLivelibRatingLoaded = 'livelib-rating_loaded';
let statusInit = false;

function createItemRating(num, count, countMarks) {
    elLivelibRating.querySelector('.livelib-rating__body')
        .insertAdjacentHTML('beforebegin', `
            <div class="livelib-rating__item">
                <div class="livelib-rating__item-left">${num}
                    <svg class="livelib-rating__item-icon"><use xlink:href="#star-acute"></use></svg>
                    <div class="livelib-rating__item-line">
                      <div class="livelib-rating__item-line-inner" style="width: ${(count * 100) / countMarks}%;"></div>
                    </div>
                </div>
                <div class="livelib-rating__item-right">${count}</div>
            </div>`);
}

function initLiveLib(id) {
    const livelib = new Livelib(id);

    statusInit = true;

    return livelib.initialRating()
        .then((data) => {
            elLivelibRating.querySelector('.livelib-rating__avg-value').textContent = data.average;
            elLivelibRating.querySelector('.livelib-rating__rating-value').textContent = data.count;

            for (let i = 5; i > 0; i--) {
                createItemRating(i, data.counts[`count${i}`], data.count);
            }
        })
        .then(() => elLivelibRating.classList.add(cLivelibRatingLoaded))
        .catch((err) => console.log(`livelib.initialRating(): ${err}`));
}

document.addEventListener('init.livelibRating.eksmo', () => {
    if (!elLivelibRating.classList.contains(cLivelibRatingLoaded) && !statusInit) {
        initLiveLib(elLivelibRating.getAttribute('data-id')).then(() => {
            const htmlLivelibRating = elLivelibRating.querySelector('.livelib-rating__main')?.cloneNode(true);

            if (htmlLivelibRating) {
                document.querySelectorAll('.livelib-rating_page').forEach((item) => {
                    const elLiveLibRatingMain = item.querySelector('.livelib-rating__main');

                    elLiveLibRatingMain.innerHTML = '';
                    elLiveLibRatingMain.append(htmlLivelibRating);
                    item.classList.add(cLivelibRatingLoaded);
                });
            }
        });
    }
});